import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import frTranslations from './locales/fr.json'
import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

// Créer les ressources avec les namespaces au bon niveau
const createResources = (fr, en, ar) => {
  // Dièse clés de top-level comme namespaces
  const namespaces = Object.keys(fr).filter(key => typeof fr[key] === 'object')
  
  return {
    fr: { translation: { ...fr }, ...namespaces.reduce((acc, ns) => { acc[ns] = fr[ns]; return acc; }, {}) },
    en: { translation: { ...en }, ...namespaces.reduce((acc, ns) => { acc[ns] = en[ns]; return acc; }, {}) },
    ar: { translation: { ...ar }, ...namespaces.reduce((acc, ns) => { acc[ns] = ar[ns]; return acc; }, {}) },
  }
}

const resources = createResources(frTranslations, enTranslations, arTranslations)

// Extraire la liste des namespaces
const namespaces = Object.keys(frTranslations).filter(key => typeof frTranslations[key] === 'object')

i18n
  .use(initReactI18next)
  .init({
    resources,
    ns: ['translation', ...namespaces],
    defaultNS: 'translation',
    fallbackLng: 'fr',
    lng: localStorage.getItem('i18nextLng') || 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
  })

export default i18n
